"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Nav = void 0;

var _react = _interopRequireWildcard(require("react"));

var _hooks = require("../../hooks");

var _utils = require("../../utils");

var _contexts = require("../../contexts");

var _navItems = require("./nav-items");

var _languages = require("./languages");

var _navModule = _interopRequireDefault(require("./nav.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Nav = function Nav() {
  var _useTheme = (0, _hooks.useTheme)(),
      pages = _useTheme.pages;

  var pagesMain = (0, _react.useMemo)(function () {
    return pages.filter(function (page) {
      return (0, _utils.getProperty)(page, "data.menu") === _contexts.MENU_MAIN;
    });
  }, [pages]);
  var pagesSide = (0, _react.useMemo)(function () {
    return pages.filter(function (page) {
      return (0, _utils.getProperty)(page, "data.menu") === _contexts.MENU_SIDE;
    });
  }, [pages]);
  return /*#__PURE__*/_react.default.createElement("nav", {
    className: _navModule.default.wrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _navModule.default.main
  }, /*#__PURE__*/_react.default.createElement(_navItems.NavItems, {
    pages: pagesMain
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: _navModule.default.container
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_navItems.NavItems, {
    pages: pagesSide
  })), /*#__PURE__*/_react.default.createElement(_languages.Languages, null))));
};

exports.Nav = Nav;